<template>
  <div>
    <div class="row">
      <div class="left color2">
        <Icon type="md-contact" />{{row.connectName}}</div>
      <div class="right color3">
        <Icon type="ios-call" />{{row.connectPhone}}</Tag>
      </div>
    </div>
    <div class="row">
      <div class="left color3">
        <Icon type="md-home" />{{row.companyName}}</div>
    </div>
  </div>
</template>
<script>
export default {
  components: {},
  props: {
    row: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data() {
    return {
      msg: null,
      companyStateLabel: null,
      companyStateColor: ''
    }
  },
  computed: {},
  created() {
  },

  methods: {
  }
}

</script>
<style scoped lang="scss">
.color1 {
  color: #17233d;
}

.color2 {
  color: #515a6e;
}

.color3 {
  color: #808695;
}

.color4 {
  color: #c5c8ce;
}

.row {
  display: flex;
  flex-direction: row;

  .left {
    flex: 1;
  }

  .right {
    flex: 1;
    // text-align: right;
  }
}

</style>
